/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'eye': {
    width: 28,
    height: 18,
    viewBox: '0 0 28 18',
    data: '<path pid="0" d="M14 0c8.318 0 14 9 14 9s-4.118 9-14 9C4.2 18 0 9 0 9s5.766-9 14-9zm0 14.726c3.212 0 5.764-2.535 5.764-5.726 0-3.19-2.552-5.726-5.764-5.726S8.236 5.809 8.236 9c0 3.19 2.552 5.726 5.764 5.726zM16.47 9A2.462 2.462 0 0114 11.454 2.462 2.462 0 0111.53 9 2.462 2.462 0 0114 6.546 2.462 2.462 0 0116.47 9z" _fill="#203F6A" fill-rule="evenodd"/>'
  }
})
